import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/Navbar.css";
import logo from "../../images/logo.png";
import {
  FaChevronDown,
  FaChevronRight,
  FaGraduationCap,
  FaBook,
  FaAward,
  FaStar,
  FaRegStar,
  FaLaptopCode,
  FaBookReader,
  FaChartLine,
  FaTrophy,
  FaSchool,
  FaComments,
  FaUsers,
  FaQuestionCircle,
  FaUserPlus,
  FaBookOpen,
  FaHandsHelping,
  FaUserCheck,
  FaFileAlt,
  FaClipboardList,
  FaUserShield
} from "react-icons/fa";

function Navbar() {
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [coursesDropdownOpen, setCoursesDropdownOpen] = useState(false);
  const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);

  // States for Services Dropdown Menus
  const [featuredSubOpen, setFeaturedSubOpen] = useState(false);
  const [nonFeaturedSubOpen, setNonFeaturedSubOpen] = useState(false);

  // States for Courses Dropdown Menus
  const [scholasticSubOpen, setScholasticSubOpen] = useState(false);
  const [competitiveSubOpen, setCompetitiveSubOpen] = useState(false);

  // States for Product Verticals Dropdown Menus (Tier 2 & Tier 3)
  const [PremiumHubOpen, setPremiumHubOpen] = useState(false);
  const [scholarsForumOpen, setScholarsForumOpen] = useState(false);
  const [kirnavaliSubOpen, setKirnavaliSubOpen] = useState(false);
  const [associativeErpSubOpen, setAssociativeErpSubOpen] = useState(false); // Tier 3 under Associative ERP

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg crest-navbar sticky-top">
      <div className="container my-5 crest-navbar-container">
        <NavLink className="navbar-brand" to="/">
          <img src={logo} alt="Crestest Logo" className="crest-logo" />
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-controls="navbarNav"
          aria-expanded={mobileMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse justify-content-end ${mobileMenuOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav align-items-lg-center">

            <li className="nav-item">
              <NavLink className="nav-link" to="/" end onClick={() => setMobileMenuOpen(false)}>
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/about" onClick={() => setMobileMenuOpen(false)}>
                About
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/unique-features" onClick={() => setMobileMenuOpen(false)}>
                Unique Features
              </NavLink>
            </li>

            {/* --- Product Verticals Dropdown Menu Item --- */}
            <li
              className="nav-item dropdown crest-custom-dropdown"
              onMouseEnter={() => setProductsDropdownOpen(true)}
              onMouseLeave={() => {
                setProductsDropdownOpen(false);
                setPremiumHubOpen(false);
                setScholarsForumOpen(false);
                setKirnavaliSubOpen(false);
                setAssociativeErpSubOpen(false);
              }}
            >
              <button
                type="button"
                className={`nav-link dropdown-toggle-custom btn-reset ${window.location.pathname.startsWith('/products') ? 'services-link-active' : ''}`}
                onClick={() => setProductsDropdownOpen(!productsDropdownOpen)}
              >
                Product Domains <FaChevronDown className="ms-1 dropdown-indicator-icon" />
              </button>

              {/* Tier 1 Product Verticals Menu */}
              <ul className={`crest-dropdown-menu ${productsDropdownOpen ? 'show-menu' : ''}`}>

                {/* 1. Premium Learning Hub (Includes Overview and Join Premium Hub) */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setPremiumHubOpen(true);
                    setScholarsForumOpen(false);
                    setKirnavaliSubOpen(false);
                    setAssociativeErpSubOpen(false);
                  }}
                  onMouseLeave={() => setPremiumHubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPremiumHubOpen(!PremiumHubOpen);
                    setScholarsForumOpen(false);
                    setKirnavaliSubOpen(false);
                    setAssociativeErpSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-blue me-3"><FaLaptopCode /></span>
                      <span className="item-text">Premium Learning Hub</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${PremiumHubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${PremiumHubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/lms"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setPremiumHubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaLaptopCode /></span>
                        <span className="item-text">Overview</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/online-exam"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setPremiumHubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaLaptopCode /></span>
                        <span className="item-text">Online Exam</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/e-library"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setPremiumHubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3"><FaBookReader /></span>
                        <span className="item-text">e-Library</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/performance-scorecard"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setPremiumHubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaChartLine /></span>
                        <span className="item-text">Performance Scorecard</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="https://lms.crestest.com/page-login"
                        target="_blank"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setPremiumHubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaUserPlus /></span>
                        <span className="item-text">Join Premium Hub</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* 2. Scholars’ Forum (Includes Overview) */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setScholarsForumOpen(true);
                    setPremiumHubOpen(false);
                    setKirnavaliSubOpen(false);
                    setAssociativeErpSubOpen(false);
                  }}
                  onMouseLeave={() => setScholarsForumOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setScholarsForumOpen(!scholarsForumOpen);
                    setPremiumHubOpen(false);
                    setKirnavaliSubOpen(false);
                    setAssociativeErpSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-yellow me-3"><FaComments /></span>
                      <span className="item-text">Scholars’ Forum</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${scholarsForumOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${scholarsForumOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/forum"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setScholarsForumOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaComments /></span>
                        <span className="item-text">Overview</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/group-discussion"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setScholarsForumOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaUsers /></span>
                        <span className="item-text">Group Discussion</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/quiz"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setScholarsForumOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaQuestionCircle /></span>
                        <span className="item-text">Quiz</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="https://forum.crestest.com/register"
                        target="_blank"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setScholarsForumOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3"><FaUserPlus /></span>
                        <span className="item-text">Join Forum</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* 3. Kirnavali */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setKirnavaliSubOpen(true);
                    setPremiumHubOpen(false);
                    setScholarsForumOpen(false);
                    setAssociativeErpSubOpen(false);
                  }}
                  onMouseLeave={() => setKirnavaliSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setKirnavaliSubOpen(!kirnavaliSubOpen);
                    setPremiumHubOpen(false);
                    setScholarsForumOpen(false);
                    setAssociativeErpSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-teal me-3"><FaTrophy /></span>
                      <span className="item-text">Kirnavali</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${kirnavaliSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${kirnavaliSubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/kirnavali"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setKirnavaliSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaBookOpen /></span>
                        <span className="item-text">Kirnavali Guide</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="https://staging-kirnavali.crestestlearning.com/"
                        target="_blank"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setKirnavaliSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaHandsHelping /></span>
                        <span className="item-text">Join Kirnavali</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* 4. Associative ERP */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setAssociativeErpSubOpen(true);
                    setPremiumHubOpen(false);
                    setScholarsForumOpen(false);
                    setKirnavaliSubOpen(false);
                  }}
                  onMouseLeave={() => setAssociativeErpSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setAssociativeErpSubOpen(!associativeErpSubOpen);
                    setPremiumHubOpen(false);
                    setScholarsForumOpen(false);
                    setKirnavaliSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-blue me-3"><FaSchool /></span>
                      <span className="item-text">Academic ERP</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${associativeErpSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${associativeErpSubOpen ? 'show-submenu' : ''}`}>
                    
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/associates"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setAssociativeErpSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaClipboardList /></span>
                        <span className="item-text">Exam Management</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/associates"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setAssociativeErpSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3"><FaFileAlt /></span>
                        <span className="item-text">Content Management</span>
                      </NavLink>
                    </li>
                     <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/associates"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setAssociativeErpSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaUserCheck /></span>
                        <span className="item-text">Admission Management</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/associates"
                        onClick={() => {
                          setProductsDropdownOpen(false);
                          setAssociativeErpSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaUserShield /></span>
                        <span className="item-text">Admin Management</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* 5. EdTech Solutions */}
                <li>
                  <NavLink
                    className="crest-dropdown-item"
                    to="/software"
                    onClick={() => {
                      setProductsDropdownOpen(false);
                      setMobileMenuOpen(false);
                    }}
                  >
                    <span className="dropdown-icon-box accent-teal me-3"><FaGraduationCap /></span>
                    <span className="item-text">EdTech Solutions</span>
                  </NavLink>
                </li>

              </ul>
            </li>

            {/* --- Courses Dropdown Menu Item --- */}
            <li
              className="nav-item dropdown crest-custom-dropdown"
              onMouseEnter={() => setCoursesDropdownOpen(true)}
              onMouseLeave={() => {
                setCoursesDropdownOpen(false);
                setScholasticSubOpen(false);
                setCompetitiveSubOpen(false);
              }}
            >
              <button
                type="button"
                className={`nav-link dropdown-toggle-custom btn-reset ${window.location.pathname.startsWith('/courses') ? 'services-link-active' : ''}`}
                onClick={() => setCoursesDropdownOpen(!coursesDropdownOpen)}
              >
                Courses <FaChevronDown className="ms-1 dropdown-indicator-icon" />
              </button>

              <ul className={`crest-dropdown-menu ${coursesDropdownOpen ? 'show-menu' : ''}`}>
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setScholasticSubOpen(true);
                    setCompetitiveSubOpen(false);
                  }}
                  onMouseLeave={() => setScholasticSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setScholasticSubOpen(!scholasticSubOpen);
                    setCompetitiveSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-blue me-3"><FaBook /></span>
                      <span className="item-text">Scholastic</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${scholasticSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${scholasticSubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <a
                        className="crest-dropdown-item"
                        href="https://cbse.crestest.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setCoursesDropdownOpen(false);
                          setScholasticSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaGraduationCap /></span>
                        <span className="item-text">CBSE</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="crest-dropdown-item"
                        href="https://icse.crestest.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setCoursesDropdownOpen(false);
                          setScholasticSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3"><FaGraduationCap /></span>
                        <span className="item-text">ICSE</span>
                      </a>
                    </li>
                  </ul>
                </li>

                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setCompetitiveSubOpen(true);
                    setScholasticSubOpen(false);
                  }}
                  onMouseLeave={() => setCompetitiveSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCompetitiveSubOpen(!competitiveSubOpen);
                    setScholasticSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-yellow me-3"><FaAward /></span>
                      <span className="item-text">Competitive</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${competitiveSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${competitiveSubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <a
                        className="crest-dropdown-item"
                        href="https://ntse.crestest.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setCoursesDropdownOpen(false);
                          setCompetitiveSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaGraduationCap /></span>
                        <span className="item-text">NTSE</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            {/* --- Services Dropdown Menu Item --- */}
            {/* <li
              className="nav-item dropdown crest-custom-dropdown"
              onMouseEnter={() => setServicesDropdownOpen(true)}
              onMouseLeave={() => {
                setServicesDropdownOpen(false);
                setFeaturedSubOpen(false);
                setNonFeaturedSubOpen(false);
              }}
            >
              <button
                type="button"
                className={`nav-link dropdown-toggle-custom btn-reset ${window.location.pathname.startsWith('/services') ? 'services-link-active' : ''}`}
                onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)}
              >
                Services <FaChevronDown className="ms-1 dropdown-indicator-icon" />
              </button>

              <ul className={`crest-dropdown-menu ${servicesDropdownOpen ? 'show-menu' : ''}`}>
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setFeaturedSubOpen(true);
                    setNonFeaturedSubOpen(false);
                  }}
                  onMouseLeave={() => setFeaturedSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFeaturedSubOpen(!featuredSubOpen);
                    setNonFeaturedSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-blue me-3"><FaStar /></span>
                      <span className="item-text">Featured services</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${featuredSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${featuredSubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/online-exam"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaLaptopCode /></span>
                        <span className="item-text">Online exam</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/e-library"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3"><FaBookReader /></span>
                        <span className="item-text">E library</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/performance-scorecard"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaChartLine /></span>
                        <span className="item-text">Performance scorecard</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setNonFeaturedSubOpen(true);
                    setFeaturedSubOpen(false);
                  }}
                  onMouseLeave={() => setNonFeaturedSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setNonFeaturedSubOpen(!nonFeaturedSubOpen);
                    setFeaturedSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-teal me-3"><FaRegStar /></span>
                      <span className="item-text">Non Featured services</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${nonFeaturedSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${nonFeaturedSubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/kirnavali"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setNonFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaTrophy /></span>
                        <span className="item-text">Kirnavali program</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/associative-erp/admission-management"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setNonFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3"><FaSchool /></span>
                        <span className="item-text">Associative erp</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/forum"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setNonFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3">
                          <FaComments />
                        </span>
                        <span className="item-text">Forum</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </li> */}

            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={() => setMobileMenuOpen(false)}>
                Contact
              </NavLink>
            </li>

            {/* <li className="nav-item">
              <NavLink className="nav-link" to="/associates" onClick={() => setMobileMenuOpen(false)}>
                Associates
              </NavLink>
            </li> */}

            <li className="nav-item ms-lg-3 mt-3 mt-lg-0">
              <a
                href="https://kirnavali.crestestlearning.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn crest-login-btn"
                onClick={() => setMobileMenuOpen(false)}
              >
                Register/Login
              </a>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;



